function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "view",
  transform: "translate(-20853 -1564)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2342",
  "data-name": "Rectangle 2342",
  transform: "translate(20853 1564)",
  fill: "#fff",
  stroke: "#a7afb9",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 26,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 27,
  height: 25,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3501",
  "data-name": "Group 3501",
  transform: "translate(20466.625 1193.292)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1382",
  "data-name": "Path 1382",
  d: "M399.1,375.709a6.728,6.728,0,1,0,4.158,12.019l.1-.082,3.87,3.87a.67.67,0,0,0,.947-.947l-3.87-3.87.082-.1a6.729,6.729,0,0,0-5.29-10.887Zm3.9,10.63a5.517,5.517,0,1,1,1.616-3.9A5.481,5.481,0,0,1,403,386.339Z",
  fill: "#a7afb9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1383",
  "data-name": "Path 1383",
  d: "M533.49,695.983a.588.588,0,0,0,0,.764c.09.105,2.225,2.575,4.946,2.575s4.857-2.471,4.947-2.576a.589.589,0,0,0,0-.764c-.09-.105-2.23-2.575-4.946-2.575S533.58,695.877,533.49,695.983Zm4.946,2.16a5.908,5.908,0,0,1-3.675-1.778,4.687,4.687,0,0,1,7.35,0A5.9,5.9,0,0,1,538.436,698.143Z",
  transform: "translate(-139.291 -313.942)",
  fill: "#a7afb9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1384",
  "data-name": "Path 1384",
  d: "M838.71,821.891a1.441,1.441,0,1,0,1.441-1.441A1.441,1.441,0,0,0,838.71,821.891Z",
  transform: "translate(-441.045 -439.47)",
  fill: "#a7afb9"
})));

var SvgViewDisabled = function SvgViewDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view_disabled.b046ba1f.svg";
export { ForwardRef as ReactComponent };